import { CoinTypography } from "Infrastructure/Components/CoinTypography";
import { useLocale } from "Infrastructure/Hooks/useLocale";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Box, useTheme } from "@mui/material";

export const RewardBadge = ({
  value,
  absolute = true,
}: {
  value: number;
  absolute?: boolean;
}) => {
  const { customSpacing, customFontWeight } = useTheme();
  const { t } = useResource();
  const locale = useLocale();

  return (
    <Box
      sx={
        absolute
          ? {
              position: "absolute",
              top: customSpacing.lg,
              right: customSpacing.lg,
            }
          : undefined
      }
    >
      <CoinTypography variant="body2" fontWeight={customFontWeight.medium}>
        {value.toLocaleString(locale)}{" "}
        {t(Resources.Pages.DetailQuest.RewardSuffix)}
      </CoinTypography>
    </Box>
  );
};
